import { getCase } from "../../content/lookups.js";
import type { CaseDefinition, GameState, Screen } from "../../domain/types/index.js";
import type { GameBgmId } from "./bgmTracks.js";

const MAP_SCREENS: readonly Screen[] = ["map", "event", "rest"];
const REWARD_SCREENS: readonly Screen[] = ["reward.card", "reward.organization"];
const CASE_SCREENS: readonly Screen[] = ["case.play", "case.resolve"];
const SILENT_CASE_KINDS = new Set(["success", "failure", "gameover"]);

function caseBgm(size: CaseDefinition["size"] | undefined): GameBgmId {
  if (size === "boss") return "bossCase";
  if (size === "large") return "largeCase";
  return "smallMediumCase";
}

function caseResultSilencesBgm(state: Pick<GameState, "resolution">): boolean {
  const resolution = state.resolution;
  const kind = resolution?.events[resolution.index]?.kind;
  return kind !== undefined && SILENT_CASE_KINDS.has(kind);
}

export function bgmForState(state: Pick<GameState, "screen" | "run" | "resolution">): GameBgmId | null {
  if (state.screen === "stageSelect" || state.screen === "bringIn") return "stageSelect";
  if (MAP_SCREENS.includes(state.screen)) return "mapSelect";
  if (REWARD_SCREENS.includes(state.screen)) return "reward";
  if (!CASE_SCREENS.includes(state.screen)) return null;
  if (caseResultSilencesBgm(state)) return null;
  return caseBgm(getCase(state.run?.activeCase?.caseId ?? "")?.size);
}
